(function () {
  var watchBodyClasses = [
    'breitling-product-page',
    'corum-product-page',
    'grand-seiko-product-page',
    'gucci-product-page',
    'hamilton-product-page',
    'longines-product-page',
    'mido-product-page',
    'norqain-product-page',
    'omega-product-page',
    'rado-product-page',
    'tagheuer-product-page',
    'tissot-product-page',
    'tudor-product-page'
  ];

  function isWatchPdp() {
    for (var i = 0; i < watchBodyClasses.length; i += 1) {
      if (document.body.classList.contains(watchBodyClasses[i])) return true;
    }
    return false;
  }

  function normalize(value) {
    return (value || '')
      .replace(/\u00a0/g, ' ')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .replace(/[.:;,\-–—]+$/g, '')
      .trim();
  }

  function isPlaceholder(value) {
    var text = normalize(value)
      .replace(/^(calibre|caliber|power reserve)\s*:?\s*/i, '')
      .replace(/[.:;,\-–—]+$/g, '')
      .trim();

    return text === 'n/a' ||
      text === 'na' ||
      text === 'not applicable' ||
      text === 'not available' ||
      text === '0';
  }

  function cleanFeatureLists() {
    if (!isWatchPdp()) return;

    var featureBoxes = document.querySelectorAll('[class$="-product__features"]');
    for (var i = 0; i < featureBoxes.length; i += 1) {
      var box = featureBoxes[i];
      var items = box.querySelectorAll('li');

      for (var j = items.length - 1; j >= 0; j -= 1) {
        if (isPlaceholder(items[j].textContent)) items[j].remove();
      }

      if (!box.querySelector('li')) box.hidden = true;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanFeatureLists, { once: true });
  } else {
    cleanFeatureLists();
  }
}());
